
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AllocationForm } from "./AllocationForm";
import type { Prize, University, PrizeAllocation } from "./types";

interface AllocationDialogsProps {
  isAddOpen: boolean;
  isEditOpen: boolean;
  setIsAddOpen: (open: boolean) => void;
  setIsEditOpen: (open: boolean) => void;
  prizes: Prize[];
  universities: University[];
  formData: {
    university_id: string;
    prize_id: string;
    daily_limit: number;
  };
  setFormData: (data: {
    university_id: string;
    prize_id: string;
    daily_limit: number;
  }) => void;
  onSubmit: (e: React.FormEvent, editingAllocation: PrizeAllocation | null) => void;
  editingAllocation: PrizeAllocation | null;
}

export function AllocationDialogs({
  isAddOpen,
  isEditOpen,
  setIsAddOpen,
  setIsEditOpen,
  prizes,
  universities,
  formData,
  setFormData,
  onSubmit,
  editingAllocation,
}: AllocationDialogsProps) {
  return (
    <>
      <Dialog open={isAddOpen} onOpenChange={setIsAddOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Add New Prize Allocation</DialogTitle>
          </DialogHeader>
          <AllocationForm
            prizes={prizes}
            universities={universities}
            formData={formData}
            setFormData={setFormData}
            onSubmit={(e) => onSubmit(e, null)}
          />
        </DialogContent>
      </Dialog>

      <Dialog open={isEditOpen} onOpenChange={setIsEditOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Edit Prize Allocation</DialogTitle>
          </DialogHeader>
          <AllocationForm
            prizes={prizes}
            universities={universities}
            formData={formData}
            setFormData={setFormData}
            onSubmit={(e) => onSubmit(e, editingAllocation)}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
